import React, { useContext, useRef } from 'react'
import { OrderDown, OrderUp } from '../Icons/OrderDefined'
import intl from 'react-intl-universal'
import { LanguageContext } from '../../contexts/LanguageContext'
import { OrderInfoContext } from '../../contexts/OrderInfo'
import { OrderMarkContext } from '../../contexts/OrderMark'
import { OrderPriceContext } from '../../contexts/OrderPrice'

import {
  OrderPay
} from './OrderStyle.js'
import {
  payOrderMeals
} from './OrderFunction'

export default function OrderDefinedPay (props) {
  const OrderInfo = useContext(OrderInfoContext)
  const OrderMark = useContext(OrderMarkContext)
  const OrderPrice = useContext(OrderPriceContext)
  const Language = useContext(LanguageContext)
  const payBotton = useRef('payBotton')
  const OrderShoppingHeight = (window.innerHeight - 50) * 0.07 < 48 ? (window.innerHeight - 50) * 0.07 : 48
  return (
    <OrderPay className={'abs bgf pl20 pr10 pt5 w100 trans lt1 b0'} style={{ transform: props.isshow ? 'translateY(0%)' : 'translateY(150%)', paddingBottom: `${OrderShoppingHeight}px` }}>
      <ul className='lh1-8 flex fs15'>
        <li className='w90 tl'>{intl.get('User Information')}</li>
        <li className='w10'>
          <div
            onClick={() => props.setIsshow(!props.isshow)}>
            {props.isshow ? <OrderDown /> : <OrderUp />}
          </div>
        </li>
      </ul>
      <ul className='lh1-8 flex g6d fs14'>
        <li className='w50 tl ti1'>{intl.get('Name of patient:')}</li>
        <li className='w50 tr pr10'>
          {OrderMark.patientName}
        </li>
      </ul>
      <ul className='lh1-8 flex g6d fs14'>
        <li className='w50 tl ti1'>
          {intl.get('Bed number:')}
        </li>
        <li className='w50 tr pr10'>
          {OrderMark.position}
        </li>
      </ul>
      <div className='lh1-8 tc fs21 fw9 lt1 pt10 g4f'>
        {intl.get('Payment required')}{' '}&yen;{OrderPrice.payPrice.toFixed(2)}
      </div>
      <div style={{ height: '2.42rem', marginBottom: '2.5rem' }}>
        <button id='payBottonid' className='abs clip' ref={payBotton}
          onClick={() => {
            payOrderMeals(payBotton, OrderInfo, OrderPrice, OrderMark, Language, props.setIsshow, props.setShowModal, props.setModalInfo, props.history, props.advanceDay)
          }}
        />
        <label htmlFor='payBottonid' className='db h100 w58 auto rds6 rel comfirm-pay lt2 tc gf' style={{ lineHeight: '2.42rem' }}>
          {intl.get('Confirmation of payment')}
        </label>
      </div>
    </OrderPay>
  )
}
